import React from 'react';
import Space from './Space';



function Spin({ loading, children, async = false, style = {}, message = false, className = "" }) {


  const _class = "loading-overlay-container" + " " + className; 
  return (
    <div style={{ ...style, pointerEvents: loading ? "none" : "auto" }} className={_class} >
      {children}
      <div className={`loading-overlay ${loading ? "visible" : ""}`}>
        <div style={{ "textAlign": "center", "margin": "0 auto" }}>
          {async && <>{async}</>}
          {message && <div style={{ "backgroundColor": "#000", "padding": "5px 15px", "borderRadius": "10px" }}>
            <Space>
              <div style={{ "margin": "0 auto", "height": "10px", "width": "10px" }} className="loader"></div>
              {message}
            </Space>
          </div>}
          {((!message && !async) && <div style={{ "margin": "0 auto" }} className="loader"></div>)}
        </div>
      </div>
    </div>
  );
}

export default Spin;
